import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckEmptyPipe } from './check-empty/check-empty.pipe';
import { FilenameSplicePipe } from './filename-splice/filename-splice.pipe';
import { ThousandComaSeperatorPipe } from './thousand-coma-seperator/thousand-coma-seperator.pipe';
import { CheckNullPipe } from './check-null/check-null.pipe';


@NgModule({
  declarations: [CheckEmptyPipe, FilenameSplicePipe, ThousandComaSeperatorPipe, CheckNullPipe],
  imports: [
    CommonModule
  ],
  exports: [CheckEmptyPipe, FilenameSplicePipe, ThousandComaSeperatorPipe, CheckNullPipe]
})
export class SharedPipesModule { }
